import type { FaireProductEntity } from "../../entity_types/product";

export const p_u7rpye8pcm: FaireProductEntity = {
  token: "p_u7rpye8pcm",
  type: "product",
  name: "I ❤️ Naps  Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a235a4e3a5d904f8198224c0cdad2416f67f8b8a61bad11cd913571fdbd1c39e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efb066c0b93fd3be243e020b4281372f5a77025ed81ebf9aa88f9b63b0a8bfb7.jpeg",
    "https://cdn.faire.com/fastly/f1b2d217b13460fa6e19fafd09a1172e2d5055e794fda0b10b55a08ec08cbd0f.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/de87db2f1c20863d6953237afd7ea0ece1f41d905f4bc491a6c12bb7ce68a694.jpeg",
    "https://cdn.faire.com/fastly/f904efcc8da48b36c0abc78890b4ade9045f928735eb3af3b90d69f749614d7e.jpeg",
    "https://cdn.faire.com/fastly/f22b637c674e7b1e4acc6c65cbb0ee3ceb69e48fefb5d36bd7dac41df31fea24.jpeg",
    "https://cdn.faire.com/fastly/6f55c898eb92cb447d247898e9c5a69f1e130194c693ab3d020deaaf0bc64184.jpeg"
  ],
  priceDollars: 9.6,
  description: "For you peak relaxation enthusiasts and people who love saying \"I'm just resting my eyes\" 😴\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:21.368Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
